<template>
  <div>
  </div>
</template>
  
<script>
  import EventBus from '../eventbus';
  import languages from './../lang/languages';
  import Cache from '../modules/Cache';
  import resources from '../resources';

export default {
  mounted() {
    const AuthTokenExpirancyKey = 'default_auth_token_expirancy';
    const AuthTokenKey = 'default_auth_token';

    localStorage.removeItem(AuthTokenKey);
    localStorage.removeItem(AuthTokenExpirancyKey);

    const token = this.$route.params.token;
    const model_id = this.$route.params.model_id;
    if (token) {
      // Intentar autenticar con el token
      this.authenticateWithToken(token, model_id);
    } else {
      console.error('No se proporcionó un token en la URL');
    };
  },
  methods: {
    authenticateWithToken(token, model_id) {
      var loginData = {
        type: 'token_login',
        token: token,
        model_id: model_id,
      };
      this.$auth.login({
        body: loginData,
        rememberMe: true,
        success: function (resp) {
          let lastSelectedLang = languages.find(lang => resp.data.last_lang_code === lang.code);

          if (lastSelectedLang) {
            EventBus.changeLanguage(lastSelectedLang);
          }

          this.$emit('successfullLogin',resp);

          const isModelLogin = Cache.getLoginAsModel();
          if (isModelLogin) {
            const data = resp.data;
            const url = resources.webstars.LoginURLWithRedirect({
              model_id: data.user.model_id,
              token: data.access_token, 
            });

            window.location.href = url;
            return true;
          } else {
            this.$router.push('/');
          }
        },
        error: function (resp) {
          this.$router.push('/');
        },
        redirect: '/',
      });
    },
    successfullAuthHandler(user) {
      if (this.$auth.user()) {
        this.$router.replace({ name: "dashboard" });
      }
    },
  }
};
</script>
  